import { EVariationTypes } from 'core/common/constants/multivariation'
import { createStore } from 'core/common/utils/store'

export type TVariationValues<T> = Record<string, T>

export interface IStoreValues {
  variationTypes: {
    first: EVariationTypes | null
    second: EVariationTypes | null
    third: EVariationTypes | null
  }
  variationValues: TVariationValues<TVariationValues<string[] | null>>
}

interface IStore extends IStoreValues {
  setVariationType: (
    key: keyof IStoreValues['variationTypes'],
    value: EVariationTypes | null
  ) => void
  getType: (key: keyof IStoreValues['variationTypes']) => EVariationTypes | null
  getValues: () => IStoreValues['variationValues']
  setValues: (values: IStoreValues['variationValues']) => void
  resetStoreValues: () => void
}

const INITIAL_STORE: IStoreValues = {
  variationTypes: {
    first: null,
    second: null,
    third: null,
  },
  variationValues: {},
}

export const useMultivariationValues = createStore<IStore>((set, get) => ({
  ...INITIAL_STORE,
  getType: type => get().variationTypes[type],
  getValues: () => get().variationValues,
  setValues: variationValues => set({ variationValues }),
  setVariationType: (key, value) =>
    set({
      variationTypes: { ...get().variationTypes, [key]: value },
    }),
  resetStoreValues: () => set(INITIAL_STORE),
}))
